const ExportIcon = () => (
  <svg
    width='14px'
    height='14px'
    viewBox='0 0 14 14'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Combined Shape</title>
    <g
      id='Export QUESTIONNAIRES'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <path
        d='M13.5,11.75 L13.5,13.25 L0.5,13.25 L0.5,11.75 L13.5,11.75 Z M7.75,0 L7.75,7.381 L10.1702905,5.33380147 L11.1394193,6.47869853 L6.97981937,9.99970352 L3.12358754,6.45867672 L4.13813121,5.35382328 L6.25,7.293 L6.25,0 L7.75,0 Z'
        id='Combined-Shape'
        fill='#8400FF'
        fillRule='nonzero'
      />
    </g>
  </svg>
)

export default ExportIcon
